__turbopack_context__.v({
  "businessNameContainer": "ContactPanel-module-scss-module__7856Gq__businessNameContainer",
  "container": "ContactPanel-module-scss-module__7856Gq__container",
  "contentContainer": "ContactPanel-module-scss-module__7856Gq__contentContainer",
  "desktopContactPanel": "ContactPanel-module-scss-module__7856Gq__desktopContactPanel",
  "divider": "ContactPanel-module-scss-module__7856Gq__divider",
  "fixedLeftbar": "ContactPanel-module-scss-module__7856Gq__fixedLeftbar",
  "footer": "ContactPanel-module-scss-module__7856Gq__footer",
  "mobile": "ContactPanel-module-scss-module__7856Gq__mobile",
  "profileImageContainer": "ContactPanel-module-scss-module__7856Gq__profileImageContainer",
  "sectionPadding": "ContactPanel-module-scss-module__7856Gq__sectionPadding",
  "shareButton": "ContactPanel-module-scss-module__7856Gq__shareButton",
  "tagline": "ContactPanel-module-scss-module__7856Gq__tagline",
});
